export default __webpack_public_path__ + "static/HumanCapitalInvestments-6e78377959d096ea669c1a8a80d43578.jpg";